import React from 'react';
import AllergenIcons from '../UI/AllergenIcons';
import DishModalTrigger from '../modals/DishModalTrigger';
import Ingredients from './Ingredients';
import TranslationModalTrigger from '../modals/TranslationModalTrigger';
import assets from '../../utils/assets';
import dl from '../../utils/device-language';
import formats from '../../utils/formats';
import features from '../../utils/features';
import { useRestaurant } from '../../utils/contexts/restaurant-context';
import parse from "html-react-parser";

export default function Details(props) {
    const { dish, showDishModal, setShowDishModal, onDetailsOpenHandler } = props;

    const { restaurant } = useRestaurant();

    const [description, setDescription] = React.useState(dish.description);

    let icons = [];

    (dish.has_sulfites) && icons.push(assets.assetsPath("images/icons/allergie/solfiti.png"));
    (dish.is_frozen) && icons.push(assets.assetsPath("images/icons/allergie/surgelati.png"));
    for (const ingredient of dish.ingredients) {
        ingredient.has_allergens && ingredient.allergens.map((allergen) => {
            let path = assets.assetsPath(allergen.image_url);
            !icons.includes(path) && icons.push(path);
            return [];
        });
    }

    React.useEffect(() => {
        (String(restaurant.id) === "6608" || String(restaurant.id) === "13040") ?
            setDescription(parse(dish.description_raw)) :
            setDescription(formats.formatDescription(dish));
    }, [dish, restaurant.id]);

    function Description(props) {
        const { description } = props;

        return (
            Array.isArray(description) ?
                description.map(chunk =>
                    typeof chunk === "string" ?
                        parse(chunk.replace(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/g, formats.replacer)) :
                        chunk) :
                parse(description.replace(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/g, formats.replacer))
        );
    }

    return (
        <div className="details relative py-1">
            {description ?
                <p className="mb-2 text-sm" style={{ whiteSpace: "pre-wrap" }}>
                    <Description description={description}></Description>
                </p> :
                <Ingredients ingredients={dish.ingredients}></Ingredients>}

            <div className="flex flex-wrap items-center pt-2">
                <AllergenIcons icons={icons}></AllergenIcons> {formats.shouldDisplayDishDetails(dish) ? <DishModalTrigger dish={dish} showDishModal={showDishModal} setShowDishModal={setShowDishModal} onDetailsOpenHandler={onDetailsOpenHandler}></DishModalTrigger> : null}
            </div>

            {(!(dl.isDeviceLanguage("it") || dl.isDeviceLanguage("it-IT")) && features.toggler().includeSuggestions()) && <TranslationModalTrigger type="dish" dish={dish}></TranslationModalTrigger>}
        </div>
    );
}
